import template from './sw-cms-block-product-slider.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
